<!--
 * @Author: DY
 * @Date: 2025-03-05 15:24:30
 * @LastEditTime: 2025-06-05 15:17:07
 * @Description: 采购计划查询【采购管理】
 * @FilePath: \ShiMo_Mobile\src\views\purchase\contractInquiry_cg\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contractInquiry_cg commonListStyles">
            <HeaderNav header-title="采购计划查询" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">采购计划编号：{{ item.collect_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.approval_status_str }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>月份：{{ item.month }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>申请方式：{{ item.method_str }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_26@2x.png" alt="">
                                            <span>预算总价：{{ item.budget_total }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>采购员：{{ item.execute_user_names }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="danger" @click="toDetail(item)">
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'contract-inquiry-cg',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'contract-inquiry-cg');
        }
        next();
    },
    data() {
        return {
            tableCode: 'plan_collect_deliver_all_list_app',
            popupShow: false,
            pageSize: 5,
        };
    },
    watch: {},
    activated() {},
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        toDetail(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'contractInquiryCgForm',
                params: {
                    data: item,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.contractInquiry_cg
    width 100%
    height 100%
    background #F0F0F0
</style>
